import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { SubmissionAttachment } from '../../../../../models/submissions/submission-attachment';
import { FileDownloadService } from '../../../../../services/file-download/file-download.service';

@Component({
  selector: 'app-variable-benefit-review-consent-waiver',
  templateUrl: './variable-benefit-review-consent-waiver.component.html',
  styleUrls: ['./variable-benefit-review-consent-waiver.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableBenefitReviewConsentWaiverComponent {
  @Input({ required: true }) consentWaiverAttachment!: SubmissionAttachment;
  @Input({ required: true }) dateSigned!: string;
  @Input({ required: true }) effectiveDate!: string;

  public readonly fileDownloadService = inject(FileDownloadService);
}
